
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAuthTabSwitcher } from '@/hooks/useAuthTabSwitcher';
import { AlertCircle } from 'lucide-react';

interface ResetFormProps {
  email: string;
  setEmail: (email: string) => void;
  handleResetPassword: (e: React.FormEvent) => void;
  loading: boolean;
  rateLimited: boolean;
  cooldownTime: number | null;
}

const ResetForm: React.FC<ResetFormProps> = ({
  email,
  setEmail,
  handleResetPassword,
  loading,
  rateLimited,
  cooldownTime
}) => {
  const { switchTab } = useAuthTabSwitcher();

  return (
    <form onSubmit={handleResetPassword} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="resetEmail">Email</Label>
        <Input
          id="resetEmail"
          type="email"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="h-9"
        />
      </div>

      <Button type="submit" className="w-full" disabled={loading || rateLimited}>
        {loading ? "Sending..." : rateLimited ? 
          `Try again in ${cooldownTime && cooldownTime > 60 ? Math.ceil(cooldownTime / 60) : 1} minute` : 
          "Send Reset Link"}
      </Button>
      
      {rateLimited && (
        <div className="flex items-center space-x-2 text-amber-600 dark:text-amber-400 text-sm mt-2 p-2 bg-amber-50 dark:bg-amber-900/20 rounded-md">
          <AlertCircle className="h-4 w-4" />
          <p>
            Too many attempts. For security reasons, please wait before requesting another reset email.
          </p>
        </div>
      )}
      
      <div className="text-center text-sm mt-4">
        <button 
          type="button"
          onClick={() => switchTab('signin')}
          className="text-primary hover:underline bg-transparent border-none p-0 cursor-pointer"
        >
          Back to Sign In
        </button>
      </div>
    </form>
  );
};

export default ResetForm;
